import { classes, belowViewPort } from "utils"
import { colors } from "design"

export const textButtonVariablesLight = {
  "--resbird-text-button-color": colors.primaryBlueGrey,
  "--resbird-text-button-hover-color": colors.darkBlueGrey,
  "--resbird-text-button-disabled": colors.disabledBlueGrey,
}

export const TextButton = ({
  className,
  onClick,
  label,
  disabled,
  ...props
}) => {
  return (
    <span
      role="button"
      tabIndex="0"
      onClick={onClick}
      aria-label={label}
      disabled={disabled}
      className={classes("text-button", className)}
      css={[
        {
          fontSize: 14,
          cursor: "pointer",
          color: "var(--resbird-text-button-color)",
          ":hover:not(:disabled)": {
            color: "var(--resbird-text-button-hover-color)",
          },
        },
        belowViewPort(1441, { fontSize: "0.75rem" }),
        disabled && {
          cursor: "not-allowed",
          color: "var(--resbird-text-button-disabled)",
        },
      ]}
      {...props}
    >
      {label}
    </span>
  )
}
